import React from "react";

const Footer: React.FC = () => (
  <footer className="footer">
    <div className="content has-text-centered">
      <p>
        Made with{" "}
        <span className="icon">
          <i className="fas fa-heart" />
        </span>{" "}
        by HackGT.
      </p>
    </div>
  </footer>
);

export default Footer;
